import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dependenciesService from '../../api/dependenciesService'

const initialState = {
  upstreamApps: [],
  downstreamApps: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: '',
}

// Fetch dependencies by database name
export const fetchDependencies = createAsyncThunk(
  'dependencies/fetchAll',
  async (databaseName, thunkAPI) => {
    try {
      return await dependenciesService.getDependencies(databaseName)
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

const dependenciesSlice = createSlice({
  name: 'dependencies',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false
      state.isError = false
      state.isSuccess = false
      state.message = ''
    },
    clearDependencies: (state) => {
      state.upstreamApps = []
      state.downstreamApps = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDependencies.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchDependencies.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        
        // Handle both formats: object with upstream/downstream OR flat array
        if (Array.isArray(action.payload)) {
          // Flat array format from API - separate by isUpstream flag
          state.upstreamApps = action.payload.filter(dep => dep.isUpstream === true)
          state.downstreamApps = action.payload.filter(dep => dep.isUpstream === false)
        } else {
          // Object format with upstream/downstream properties (mock data)
          state.upstreamApps = action.payload.upstream || []
          state.downstreamApps = action.payload.downstream || []
        }
      })
      .addCase(fetchDependencies.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
  },
})

export const { reset, clearDependencies } = dependenciesSlice.actions
export default dependenciesSlice.reducer
